import { createSelector } from 'reselect';
import { getFormValues, isInvalid } from 'redux-form';
import { FORM_NAME } from './constants';
import { initialState } from './reducer';

export const selectAccreditationCompanyModalDomain = state => state.accreditationCompanyModalReducer || initialState;

export const getIsSendingAccreditationSelector = () =>
	createSelector(selectAccreditationCompanyModalDomain, ({ isSendingAccreditation }) => isSendingAccreditation);

export const getOrgTypesSelector = () =>
	createSelector(selectAccreditationCompanyModalDomain, ({ orgTypes }) => orgTypes);

export const getIsOrgTypesLoadingSelector = () =>
	createSelector(selectAccreditationCompanyModalDomain, ({ isOrgTypesLoading }) => isOrgTypesLoading);

export const getTaxSystemsSelector = () =>
	createSelector(selectAccreditationCompanyModalDomain, ({ taxSystems }) => taxSystems);

export const getIsTaxSystemsLoadingSelector = () =>
	createSelector(selectAccreditationCompanyModalDomain, ({ isTaxSystemsLoading }) => isTaxSystemsLoading);

export const getTaxRatesSelector = () =>
	createSelector(selectAccreditationCompanyModalDomain, ({ taxRates }) => taxRates);

export const getIsTaxRatesLoadingSelector = () =>
	createSelector(selectAccreditationCompanyModalDomain, ({ isTaxRatesLoading }) => isTaxRatesLoading);

export const getTaxSystemIdSelector = () =>
	createSelector(
		state => getFormValues(FORM_NAME)(state) || {},
		formValues => formValues.company?.tax_system_id || null,
	);

export const getFormIsInvalidSelector = () => createSelector(isInvalid(FORM_NAME), isInvalid => isInvalid);

export const getFormInitialValuesSelector = () =>
	createSelector(selectAccreditationCompanyModalDomain, ({ companyInfo }) => {
		if (!companyInfo) {
			return {};
		}

		return {
			company: {
				org_type_id: companyInfo.org_type?.id || '',
				tax_system_id: companyInfo.tax_system?.id || '',
				tax_rate_id: companyInfo.tax_rate?.id || '',
			},
		};
	});

export const getDataForRequestSelector = () => createSelector(getFormValues(FORM_NAME), formValues => formValues);
